import { render, staticRenderFns } from "./SpecPopover.vue?vue&type=template&id=b15a044c&scoped=true&lang=pug&"
import script from "./SpecPopover.vue?vue&type=script&lang=js&"
export * from "./SpecPopover.vue?vue&type=script&lang=js&"
import style0 from "./SpecPopover.vue?vue&type=style&index=0&id=b15a044c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a044c",
  null
  
)

export default component.exports